module.exports = __webpack_public_path__ + "media/volvo/assets/images/unlock-4b5a0c69221c14cdf43283bef93f2cb2.jpg";